import { StaticStoreState } from './StaticStoreState'

type StaticStoreDiffState = Partial<StaticStoreState> | { toJS: () => Partial<StaticStoreState> }

const staticStore: Partial<StaticStoreState> = {}
export default staticStore

export const getChangedSchema = (object: StaticStoreDiffState): Partial<StaticStoreState> =>
  ({
    ...(hasToJS(object) ? object.toJS() : object),
    updatedAt: new Date().toUTCString(),
    updatedBy: staticStore.userFullName
  }) as Partial<StaticStoreState>

function hasToJS(object: StaticStoreDiffState): object is { toJS: () => Partial<StaticStoreState> } {
  return (object as { toJS?: () => Partial<StaticStoreState> }).toJS !== undefined
}
